<template>
  <div class="paycode">
    <div class="paycode-barcode" @click="showBarCode()">
      <canvas id="barcode"></canvas>
      <div class="paycode-barcode-text">
        <div
          v-for="(item, index) in qrCodeFormatList"
          :key="index"
          class="paycode-barcode-text-item"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="paycode-qrcode">
      <canvas id="qrcode" @click="previewQrCode()"></canvas>
    </div>
    <div class="paycode-split"></div>
    <div class="paycode-card" @click="showCardList(true)">
      <Card
        class="paycode-card-text"
        :cardinfo="selectedCard"
        font-color="#000000"
      ></Card>
      <div class="paycode-card-arrow"></div>
    </div>
    <div v-if="showPayGuide" class="paycode-discount">
      <div class="paycode-discount-split"></div>
      <div class="paycode-discount-body">
        <div class="paycode-discount-body-text">
          {{ payTypeGuide.desc }}
        </div>
        <div class="paycode-discount-body-button">
          <span @click="showCardList(true)">{{ payTypeGuide.buttonText }}</span>
        </div>
      </div>
    </div>
    <transition name="qrpreview">
      <div
        v-show="qrCodePreview"
        class="qrcode-preview"
        @click="closePreview()"
      ></div>
    </transition>
    <transition name="tippreview">
      <div v-show="tipPreview" class="tip-preview">
        <div class="tip-preview-box">
          <div class="tip-preview-box-text">
            付款码数字仅用于支付时向收银员展示 请勿发送给他人，以防诈骗
          </div>
          <div class="tip-preview-box-btn" @click="previewBarCode()">
            <div class="tip-preview-box-btn-text">知道了</div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="barpreview">
      <div
        v-show="barCodePreview"
        class="barcode-preview"
        @click="closePreview()"
      >
        <div class="barcode-preview-box">
          <div class="barcode-preview-box-text">
            <div
              v-for="(item, index) in qrCodePreviewList"
              :key="index"
              class="barcode-preview-box-text-item"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import Card from './card'
const QRCode = require('qrcode')
export default {
  name: 'PayCode',
  components: {
    Card,
  },
  props: {
    qrCode: {
      type: String,
      default: '',
    },
    selectedCard: {
      type: Object,
      default: () => {},
    },
    payTypeGuide: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      qrCodePreview: false,
      barCodePreview: false,
      tipPreview: false,
    }
  },
  computed: {
    showPayGuide() {
      if (!this.payTypeGuide) return false
      if (this.payTypeGuide.bankcardId === this.selectedCard.bankcardId) {
        return false
      }
      return true
    },
    qrCodeFormatList() {
      return [this.qrCode.slice(0, 4), '****', '查看数字']
    },
    qrCodePreviewList() {
      const list = []
      for (let i = 0; i < this.qrCode.length; i++) {
        if (i === 0) continue
        if (i % 4 === 0) {
          list.push(this.qrCode.slice(i - 4, i))
        }
        if (i === this.qrCode.length - 1 && i % 4 !== 0) {
          list.push(this.qrCode.slice(-((i % 4) + 1)))
        }
      }
      return list
    },
  },
  watch: {
    qrCode() {
      this.resizeQrCode()
    },
  },
  created() {},
  mounted() {
    // 绘制一维码
    this.drawBarCode()
    // 绘制二维码
    this.drawQRCode()
    this.$lx.payTypeMV({
      bank_name: this.selectedCard.text && this.selectedCard.text.split('(')[0],
      bank_type_id: this.selectedCard.bankcardId,
      promotion: this.selectedCard.promotionDetails || [],
    })
    this.$eb.$on('closePreview', this.closePreview)
    this.$eb.$on('resizeQrCode', this.resizeQrCode)
  },
  beforeDestroy() {
    this.$eb.$off('closePreview')
    this.$eb.$off('resizeQrCode')
  },
  methods: {
    drawBarCode() {
      const start = Date.now()
      JsBarcode('#barcode', this.qrCode, {
        format: 'CODE128',
        width: (document.body.offsetWidth / 375 / 156) * 305,
        height: (document.body.offsetWidth / 375) * 77,
        displayValue: false,
        margin: 0,
      })
      const duration = Date.now() - start
      // this.$lx.codeDrawing({
      //   custom: {
      //     codeType: 'barcode',
      //     duration,
      //   },
      // })
      const metricInst = window.Owl && window.Owl.MetricManager()
      metricInst &&
        metricInst.setTags({
          type: 'barCode',
        })
      metricInst && metricInst.setMetric('draw_code', duration)
      this.$lx.codeMV({ codeType: 'barcode', duration })
    },
    drawQRCode() {
      const start = Date.now()
      const qrCodeNode = document.querySelector('#qrcode')
      QRCode.toCanvas(
        qrCodeNode,
        this.qrCode,
        { margin: 0, width: (document.body.offsetWidth / 375) * 160 },
        (err) => {
          const duration = Date.now() - start
          // this.$lx.codeDrawing({
          //   custom: {
          //     codeType: 'qrcode',
          //     duration,
          //   },
          // })
          const metricInst = window.Owl && window.Owl.MetricManager()
          metricInst &&
            metricInst.setTags({
              type: 'qrCode',
            })
          metricInst && metricInst.setMetric('draw_code', duration)
          this.$lx.codeMV({ codeType: 'qrcode', duration })
        }
      )
    },
    resizeQrCode() {
      this.drawBarCode()
      this.drawQRCode()
      if (this.barCodePreview) {
        this.drawBarPreview()
      }
      if (this.qrCodePreview) {
        this.previewQrCode()
      }
    },
    showCardList(flag) {
      this.$eb.$emit('showCardList', flag)
      this.$lx.payTypeMC({
        bank_name:
          this.selectedCard.text && this.selectedCard.text.split('(')[0],
        bank_type_id: this.selectedCard.bankcardId,
        promotion: this.selectedCard.promotionDetails || [],
      })
    },
    previewQrCode() {
      // 获取预览容器
      const box = document.querySelector('.qrcode-preview')
      // 清空容器所有子节点
      box.innerHTML = ''
      // 创建新的canvas标签
      const previewCanvas = document.createElement('canvas')
      QRCode.toCanvas(previewCanvas, this.qrCode, {
        margin: 0,
        width: (document.body.offsetWidth / 375) * 240,
      })
      box.appendChild(previewCanvas)
      this.qrCodePreview = true
      KNB.use('setStatusBarStyle', {
        style: 1,
        backgroundColor: '#FFFFFF',
      })
      document.body.style.overflow = 'hidden'
    },
    showBarCode() {
      const tipNode = document.querySelector('.tip-preview-box')
      tipNode.style.transform = 'rotate(-270deg)'
      KNB.use('setStatusBarStyle', {
        style: 1,
        backgroundColor: '#FFFFFF',
      })
      // 获取一维码容器
      this.barCodePreview = true
      const _box = document.querySelector('.barcode-preview')
      _box.style.filter = 'blur(8px)'
      document.body.style.overflow = 'hidden'
      this.drawBarPreview()
      this.tipPreview = true
    },
    drawBarPreview() {
      // 获取预览容器
      const box = document.querySelector('.barcode-preview-box')
      // 删除旧canvas节点
      if (box.lastChild && box.lastChild.nodeName === 'CANVAS') {
        box.removeChild(box.lastChild)
      }
      // 创建新的canvas标签
      const previewCanvas = document.createElement('canvas')
      JsBarcode(previewCanvas, this.qrCode, {
        format: 'CODE128',
        // width与绘制后的宽度比为156
        width: (document.body.offsetWidth / 375 / 156) * 500,
        height: (document.body.offsetWidth / 375) * 130,
        displayValue: false,
        margin: 0,
      })
      box.appendChild(previewCanvas)
      box.style.transform = 'rotate(-270deg)'
    },
    previewBarCode() {
      this.tipPreview = false
      // 获取一维码容器
      const box = document.querySelector('.barcode-preview')
      box.style.filter = 'blur(0)'
    },
    closePreview(screenShot = false) {
      if (this.tipPreview && screenShot) {
        this.$modal.hide()
        return
      }
      if (this.barCodePreview && screenShot) {
        this.barCodePreview = false
        this.$eb.$emit('getOnlineQrCode')
        this.showBarCode()
        this.$modal.hide()
        return
      }
      this.qrCodePreview = false
      this.barCodePreview = false
      document.body.style.overflow = 'auto'
      KNB.use('setStatusBarStyle', {
        style: 0,
        backgroundColor: '#FFC300',
      })
    },
    togglePreview(id, force = false) {
      if (this.previewCode && !force) {
        this.previewCode = false
      } else {
        // 获取预览容器
        const box = document.querySelector('.code-preview')
        // 获取待copy的canvas
        const node = document.querySelector(`#${id}`)
        // 创建新的canvas标签
        const previewNode = document.createElement('canvas')
        const _ctx = node.getContext('2d')
        // 获取新canvas画布的上下文
        const ctx = previewNode.getContext('2d')
        if (id === 'qrcode') {
          // 清空容器所有子节点
          box.innerHTML = ''
          previewNode.classList.add('preview-qrcode')
          previewNode.width = 200
          previewNode.height = 200
          ctx.drawImage(node, 0, 0, 160, 160, 0, 0, 200, 200)
        } else if (id === 'barcode') {
          // 清除容器最后一个子节点--条形码
          // box.removeChild(box.lastChild)
          this.tipPreview = true
          previewNode.classList.add('preview-barcode')
          previewNode.width = screen.width
          previewNode.height = screen.height
          ctx.translate(screen.width / 2, screen.height / 2)
          ctx.rotate((90 * Math.PI) / 180)
          ctx.scale(2, 2)
          ctx.drawImage(node, -312 / 2, -73 / 2, 312, 73)
        }
        box.appendChild(previewNode)
        this.previewCode = !this.previewCode
      }
    },
  },
}
</script>
<style lang="less">
@import '../assets/variable.less';
.paycode {
  width: 100%;
  border-radius: 9px;
  background: #ffffff;
  margin-top: 10px;
  &-barcode {
    .flex-column-center();
    padding: 20px 20px 0;
    width: 100%;
    &-text {
      .font-area(14px);
      margin-top: 10px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.7);
      text-align: center;
      line-height: 14px;
      .flex-center(flex-start);
      &-item {
        margin-right: 5px;
      }
      &-item:last-child {
        margin-right: 0;
      }
    }
  }
  &-qrcode {
    .flex-column-center();
    margin-top: 30px;
    position: relative;
  }
  &-split {
    height: 1px;
    width: 305px;
    background: #e5e5e5;
    transform: scaleY(0.5);
    margin: 30px auto 0;
  }
  &-card {
    .flex-center(space-between);
    padding: 0 20px;
    position: relative;
    &-text {
      padding: 19px 0;
      width: 100%;
    }
    &-arrow {
      width: 5px;
      height: 8px;
      .bg-img(
        url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAYCAYAAAAlBadpAAAAAXNSR0IArs4c6QAAANdJREFUOBGd1EEOgjAQBVCmHqE7l7RbT+IdXKB74iX0BK4kLjyEnqbdeY46Q2gDoTQzbUIIybzfAdJprLVXY8yvbdt7CAEawQKCiPaTeTnnLgAQOBkK4XtW2GHYwO0AqBDBEwPOsxBWB+M71gakDzQFDLh7x+0gYQLSgAWWBqywJCCLuQGbmBNQxIWAo/f+o6igdhVx4dd9acPNtgswHZws5sDszly4whK4wFKYcA0ccS0krHCK3PDOPsOE4lI47E7xAe+s8RPrd1prmpQHvB44OXvu5KSAP0VZv3QOiYRzAAAAAElFTkSuQmCC)
      );
    }
  }
  &-discount {
    .flex-column-center();
    &-split {
      height: 1px;
      width: 100%;
      background: #e5e5e5;
      transform: scaleY(0.5);
    }
    &-body {
      .flex-center(space-between);
      width: 100%;
      height: 60px;
      padding: 0 20px;
      background: rgba(0, 0, 0, 0.02);
      border-radius: 0 0 9px 9px;
      &-text {
        .font-area(12px);
        font-family: PingFangSC-Regular;
        color: #ff6000;
      }
      &-button {
        .flex-center(center);
        width: 78px;
        height: 30px;
        background: #ffd100;
        border-radius: 6px;
        > span {
          .font-area(12px);
          font-family: PingFangSC-Semibold;
          color: #000000;
        }
      }
    }
  }
}
.qrcode-preview,
.barcode-preview,
.tip-preview {
  .flex-center(center);
  position: absolute;
  left: 0;
  top: 0;
  background: #ffffff;
  width: 100vw;
  height: 100vh;
}
.tip-preview {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 5px;
  z-index: 1000;
}
.barcode-preview {
  z-index: 999;
}
.qrcode-preview {
  z-index: 1000;
}
.tip-preview-box {
  position: absolute;
  width: 278px;
  height: 153px;
  left: 50%;
  top: 50%;
  margin-left: -139px;
  margin-top: -76.5px;
  z-index: 1000;
  .flex-column-center();
  &-text {
    width: 278px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.9);
    text-align: center;
    line-height: 30px;
  }
  &-btn {
    margin-top: 48px;
    .flex-center(center);
    width: 140px;
    height: 45px;
    background: #ffd100;
    border-radius: 9px;
    &-text {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.7);
      text-align: center;
      line-height: 20px;
    }
  }
}
.barcode-preview-box {
  z-index: 999;
  .flex-column-center();
  &-text {
    .font-area(14px);
    font-family: PingFangSC-Regular;
    font-size: 22px;
    color: rgba(0, 0, 0, 0.9);
    letter-spacing: 9px;
    text-align: center;
    line-height: 22px;
    margin-bottom: 30.5px;
    .flex-center(flex-start);
    &-item {
      margin-right: 10px;
    }
    &-item:last-child {
      margin-right: 0;
    }
  }
}
.qrpreview-enter-active {
  transition: all 0.5s;
}
.qrpreview-enter,
.qrpreview-leave-to {
  opacity: 0;
  transform: scale(0.67);
}
.barpreview-enter-active,
.tippreview-enter-active {
  transition: all 0.5s;
}
.barpreview-enter,
.barpreview-leave-to,
.tippreview-enter,
.tippreview-leave-to {
  opacity: 0;
}
.tippreview-enter,
.barpreview-enter {
  transform: rotate(-90deg);
}
</style>
